'use client'

import { useProducts } from '@repo/shop/hooks'
import { Skeleton } from '@repo/ui/components/skeleton'
import { FunctionComponent } from 'react'
import { useRecentlyViewed } from '../../../providers/RecentlyViewedProvider'
import { PageDto } from '../../../types/page.types'
import { ProductDto } from '../../../types/product.types'
import ShopProductGrid from '../../product-grid-item/ShopProductGrid'
import ProductStickySection from './ProductStickySection'

interface Props {
  pageDto: PageDto
  productDto: ProductDto
  limit?: number
}

const ProductRecentlyViewed: FunctionComponent<Props> = ({ pageDto, limit = 4 }) => {
  const { recentlyViewedProductUrlSlugs } = useRecentlyViewed()

  const { data: recentlyViewedProducts, isLoading } = useProducts({
    locale: pageDto.params.locale,
    options: { revalidateOnFocus: false },
    // Do not add current product to list of URL slugs to retrieve.
    urlSlugs: recentlyViewedProductUrlSlugs.slice(1, limit + 1),
  })

  if (!isLoading && (recentlyViewedProductUrlSlugs.length === 0 || !recentlyViewedProducts || recentlyViewedProducts.length === 0)) {
    return null
  }

  return (
    <ProductStickySection title={pageDto.dictionary?.product?.recentlyviewed || 'Recently Viewed'}>
      {!isLoading && recentlyViewedProducts && <ShopProductGrid className='lg:[&>*:nth-child(n+4)]:hidden' pageDto={pageDto} products={recentlyViewedProducts} />}
      {isLoading && (
        <div
          aria-busy='true'
          className='divide grid aspect-[480/836] w-full auto-rows-fr grid-cols-2 items-stretch divide-x divide-y divide-solid divide-[var(--color-background,_white)] lg:aspect-[1472/624] lg:grid-cols-4 lg:[&>*:nth-child(n+4)]:hidden'
        >
          {Array.from({ length: limit }, (_, i) => (
            <Skeleton key={i} className='size-full rounded-none' aria-busy={undefined} />
          ))}
        </div>
      )}
    </ProductStickySection>
  )
}

export default ProductRecentlyViewed
